<div class="space-y-2 text-left" [class]="noMarginTop ? '' : 'mt-5'">
  @if (label) {
    <label class="text-style-form-label" [class.text-gray-200]="disabled" [class.cursor-not-allowed]="disabled">
      {{ label | translate }}
      @if (isRequired) {
        <span class="text-red-500">*</span>
      }
    </label>
  }
  <div class="relative">
    <div class="custom-option-select" [class]="customClasses" [class.disabled]="disabled">
      <div
        #selectionDiv
        role="combobox"
        [attr.aria-expanded]="openSelection"
        [attr.aria-controls]="'options-list'"
        [attr.aria-label]="label"
        [attr.aria-activedescendant]="currentOption ? 'option-' + currentOption.value : null"
        [attr.aria-disabled]="disabled"
        tabindex="0"
        class="selection-div w-full clickable border"
        [class.border-black]="openSelection"
        [class.ring-1]="openSelection"
        [class.ring-black]="openSelection"
        [class.ring-opacity-20]="openSelection"
        [class.border-gray-300]="!openSelection"
        [class.bg-gray-100]="disabled"
        [class.text-gray-500]="disabled"
        [class.cursor-not-allowed]="disabled"
        (click)="!disabled && (openSelection = !openSelection)"
        (keydown)="handleKeydown($event)"
      >
        <span class="selected-option px-4 py-2.5">
          {{ (currentOption ? currentOption.name || '' : '') | formatExchangeName | translate }}
        </span>
        <a
          class="dropdown-button absolute right-3"
          role="button"
          [attr.aria-label]="'open selection' | translate"
          tabindex="-1"
        >
          <mat-icon
            class="drop-button text-gray-400"
            [class.rotate-180]="!openSelection"
            [class.rotate-0]="openSelection"
            aria-hidden="true"
            svgIcon="arrow-up"
          ></mat-icon>
        </a>
      </div>
      @if (openSelection) {
        <div
          id="options-list"
          role="listbox"
          class="options clickable absolute w-full z-10 bg-white border rounded-lg mt-1 shadow-lg"
          [attr.aria-label]="'select an option' | translate"
        >
          @for (option of options; track option; let last = $last; let first = $first; let i = $index) {
            <div
              role="option"
              [id]="'option-' + option.value"
              [attr.aria-selected]="currentOption?.value === option.value"
              [attr.aria-disabled]="option.value === 'disabled'"
              class="options-wrapper"
              (click)="selectedOption(option)"
              [tabindex]="i === focusedOptionIndex ? 0 : -1"
              (keydown.enter)="selectedOption(option)"
              (keydown.space)="selectedOption(option)"
            >
              @if (!first) {
                <span class="styled-separator border-t border-gray-200"></span>
              }
              @if (option.value !== 'disabled') {
                <a
                  class="option px-4 py-2.5 block hover:bg-[#F6F6F6]"
                  [class.last-option]="last"
                  [class.bg-[#F6F6F6]]="i === focusedOptionIndex"
                >
                  {{ option.name || '' | formatExchangeName | translate }}
                </a>
              }
              @if (option.value === 'disabled') {
                <a class="option px-4 py-2.5 block text-gray-400 cursor-not-allowed" [class.last-option]="last">
                  {{ option.name || '' | translate }}
                </a>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
